import { themeGet } from "@styled-system/theme-get";
import { useTheme } from "@emotion/react";
import type { Theme } from "@mos-cat/ds-theme";
import type { CSSObject } from "@styled-system/css";
import { ecss } from "../reexports/emotion";

export const scrollStyles = (theme: Theme): CSSObject => {
  let white = themeGet("colors.white")({ theme }) as string;
  let scrollColor = themeGet("colors.scrollColor")({ theme }) as string;

  return {
    scrollbarWidth: "thin" /* FF */,
    scrollbarColor: `${scrollColor} ${white}` /* FF */,
    scrollbarBaseColor: white /* IE */,
    scrollbarFaceColor: scrollColor /* IE */,
    scrollbar3dlightColor: white /* IE */,
    scrollbarHighlightColor: white /* IE */,
    scrollbarTrackColor: white /* IE */,
    scrollbarArrowColor: white /* IE */,
    scrollbarShadowColor: scrollColor /* IE */,
    scrollbarDarkShadowColor: white /* IE */,
    /* Safari, Chromium */
    "::-webkit-scrollbar": {
      width: "24px" /* width of the entire scrollbar */,
    },
    "::-webkit-scrollbar-track": {
      background: white /* color of the tracking area */,
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: scrollColor /* color of the scroll thumb */,
      borderRadius: "24px" /* roundness of the scroll thumb */,
      border: `8px solid ${white}` /* creates padding around scroll thumb */,
    },
  };
};

export default function useScrollStyles() {
  let theme = useTheme();
  return ecss(scrollStyles(theme));
}
